import type { CSSProperties } from 'react';

export const APP_FOLDER_BLUE = '#4285F4';

interface AppFolderIconProps {
  width?: number;
  height?: number;
  color?: string;
  plus?: boolean;
  style?: CSSProperties;
}

export function AppFolderIcon({
  width = 20,
  height = 16,
  color = APP_FOLDER_BLUE,
  plus = false,
  style,
}: AppFolderIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      <path
        d="M4.433 22h15.134A2.433 2.433 0 0022 19.567V8.866a2.433 2.433 0 00-2.433-2.433h-6.2a1 1 0 01-.768-.36L11.036 4.22A2.433 2.433 0 009.167 3.4H4.433A2.433 2.433 0 002 5.833v13.734A2.433 2.433 0 004.433 22z"
        fill={color}
      />
      {plus && (
        <path
          d="M12 11v6M9 14h6"
          stroke="#FFFFFF"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}
